import React, { useState } from 'react';
import {
  Container,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  makeStyles,
  Input,
  ListItemText,
  Checkbox,
  FormHelperText,
} from '@material-ui/core';
import clsx from 'clsx';
import { editApiKeyAuthDomains } from '../../redux/actions/managementActions';
import { useSelector, useDispatch } from 'react-redux';
import LoadingButton from '../widgets/LoadingButton';
import { isEmpty } from 'lodash';
import { useIntl } from 'react-intl';
import { getAllFromDividedQuery } from '../../util/helpers/redux';
import LoadingCircle from '../widgets/LoadingCircle';
import { isLoaded } from 'react-redux-firebase';
import { hasApiKeys } from '../../util/helpers/user';

const useStyles = makeStyles((theme) => ({
  container: {
    ...theme.container(2),
    marginLeft: 0,
    maxWidth: '800px',
  },
  title: {
    color: theme.palette.other.grey.dark,
    marginBottom: theme.spacing(2),
  },
  formControl: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 10 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  getContentAnchorEl: () => null,
};

export default function EditApiKeyAuthDomains(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const intl = useIntl();
  const { apiKeysData, ui, profile } = useSelector(({ firebase: { profile }, firestore, ui }) => ({
    apiKeysData: hasApiKeys(profile) ? getAllFromDividedQuery(firestore, 'APIKeys') : {},
    profile,
    ui,
  }));

  const { match } = props;
  const { isLoaded: apiKeysIsLoaded, data: apiKeys } = apiKeysData;

  const apiKeyId = match.params.apiKeyId;
  const apiKeyData = (apiKeysIsLoaded && apiKeys[apiKeyId]) || undefined;

  const availableDomains = (isLoaded(profile) && profile.authDomains) || [];
  const [domains, setDomains] = useState(apiKeyData ? apiKeyData.authDomains : []);
  const [domainError, setDomainError] = useState(undefined);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isEmpty(domains)) {
      setDomainError(intl.formatMessage({ id: 'editApiKeyAuthDom.domainRequired' }));
      return;
    }
    setDomainError(undefined);

    dispatch(
      editApiKeyAuthDomains({
        domains: domains,
        apiKeyId: apiKeyId,
      })
    );
  };

  return (
    <Container className={classes.container}>
      <form onSubmit={handleSubmit}>
        <Typography variant="h4" className={clsx(classes.title)}>
          {intl.formatMessage(
            { id: 'editApiKeyAuthDom.title' },
            { licenseDescription: apiKeyData && apiKeyData.description }
          )}
        </Typography>

        {apiKeysIsLoaded ? (
          !isEmpty(availableDomains) ? (
            <>
              <FormControl className={classes.formControl}>
                <InputLabel id="authDomains-select-label">
                  {intl.formatMessage({ id: 'editApiKeyAuthDom.authDomains' })}
                </InputLabel>
                <Select
                  labelId="authDomains-select-label"
                  id="authDomains-select"
                  multiple
                  value={domains}
                  onChange={(e) => {
                    setDomains(e.target.value);
                    setDomainError(undefined);
                  }}
                  input={<Input />}
                  renderValue={(selected) => selected.join(', ')}
                  error={!!domainError}
                  MenuProps={MenuProps}
                >
                  {availableDomains.map((domain) => (
                    <MenuItem key={domain} value={domain}>
                      <Checkbox checked={domains.indexOf(domain) > -1} />
                      <ListItemText primary={domain} />
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText error>{domainError}</FormHelperText>
              </FormControl>
              <LoadingButton
                isLoading={ui.loadingButton.isEditApiKeyAuthDomainsLoading}
                content={intl.formatMessage({ id: 'saveChanges' })}
                disabled={!availableDomains || availableDomains.length === 0}
                type="submit"
              />
            </>
          ) : (
            <Typography>{intl.formatMessage({ id: 'editApiKeyAuthDom.noDomainsAvailable' })}</Typography>
          )
        ) : (
          <LoadingCircle />
        )}
      </form>
    </Container>
  );
}
